import { MaterialTypeCategory } from "@tfg/db"

import { CertificateStatus } from "@tfg/types/constants/certificates.constants"
import {
  AGECResponses,
  RecycledMaterialPercentageCause,
} from "@tfg/types/endpoints/agec"

import { useAuth } from "~/store/auth-context"

// TODO remove after plugging agecData
export const agecData: AGECResponses.GenericAgecData = {
  productSheetGroupId: "e0e17022-f85e-45c8-9a2f-c8a1555cfb7d",
  organizationName: "Company Name",
  productAttributes: {
    name: "White tshirt",
    brand: "Fashion Brand",
    color: "sand",
    collection: "Summer 2025",
    brandReference: "1234567890",
    purchaseOrderReference: "1234567890",
  },
  type: "other-apparel",
  brand: null,
  lastUpdate: "07/03/2025",
  operations: [
    {
      id: "product-APPAREL_MANUFACTURING-11424",
      type: "product",
      itemId: 64962,
      country: { country: "CN" },
      childrenRef: ["component-FABRIC_WEAVING_OR_KNITTING-22059"],
      activityName: "APPAREL_MANUFACTURING",
      certificates: [
        {
          name: "Social Audit Proof (ICS  BSCI or SMETA only accepted)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Social Audit Proof (ICS  BSCI or SMETA only accepted)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
      ],
    },
    {
      id: "component-FABRIC_WEAVING_OR_KNITTING-22059",
      type: "component",
      itemId: 64963,
      country: { country: "CN" },
      childrenRef: ["component-FABRIC_DYEING_PRINTING-22059"],
      activityName: "FABRIC_WEAVING_OR_KNITTING",
      certificates: [
        /* same pattern as above */
      ],
    },
    {
      id: "component-FABRIC_DYEING_PRINTING-22059",
      type: "component",
      itemId: 64963,
      country: { country: "CN" },
      childrenRef: [
        "material-FABRIC_SPINNING-31486",
        "material-FABRIC_SPINNING-31487",
      ],
      activityName: "FABRIC_DYEING_PRINTING",
      certificates: [],
    },
    {
      id: "material-FABRIC_SPINNING-31486",
      type: "material",
      itemId: 64964,
      country: { country: "CN" },
      childrenRef: ["material-FABRIC_MATERIAL_PRODUCTION-31486"],
      activityName: "FABRIC_SPINNING",
      certificates: [],
    },
    {
      id: "material-FABRIC_MATERIAL_PRODUCTION-31486",
      type: "material",
      itemId: 64964,
      country: { country: "CN" },
      childrenRef: [],
      activityName: "FABRIC_MATERIAL_PRODUCTION",
      certificates: [],
    },
    {
      id: "material-FABRIC_SPINNING-31487",
      type: "material",
      itemId: 64965,
      country: { country: "CN" },
      childrenRef: ["material-FABRIC_MATERIAL_PRODUCTION-31487"],
      activityName: "FABRIC_SPINNING",
      certificates: [],
    },
    {
      id: "material-FABRIC_MATERIAL_PRODUCTION-31487",
      type: "material",
      itemId: 64965,
      country: { country: "CN" },
      childrenRef: [],
      activityName: "FABRIC_MATERIAL_PRODUCTION",
      certificates: [],
    },
  ],
  operationChainName: "APPAREL",
  recycledFibers: {
    percentage: 0,
    cause:
      RecycledMaterialPercentageCause.BY_INGESTED_MATERIAL_COMPOSITION_RECYCLED_PERCENTAGE,
  },
  picture: "/old-youth-b09YYPi7NR4-unsplash.jpg",
  releasesMicroPlastic: true,
  agecActivityCountries: [
    { activityName: "APPAREL_MANUFACTURING", country: { country: "CN" } },
    { activityName: "FABRIC_WEAVING_OR_KNITTING", country: { country: "IN" } },
    { activityName: "FABRIC_DYEING_PRINTING", country: { country: "FR" } },
    { activityName: "FABRIC_DYEING_PRINTING", country: { country: "DE" } },
    { activityName: "FABRIC_DYEING_PRINTING", country: { country: "US" } },
  ],
  withPrimaryPackaging: false,
  primaryPackagingRecyclable: false,
  primaryPackagingRecycledPercentage: null,
  primaryPackagingHazardousSubstances: false,
  components: [
    {
      itemId: 1,
      certificates: [],
      type: "component",
      translations: {
        EN: "Main component",
        FR: "Composant principal",
        ES: "Componente principal",
        DE: "Hauptkomponente",
        IT: "Componente principale",
        NL: "Hoofdkomponente",
        id: 1,
        originalText: "Main component",
      },
      materials: [
        {
          type: {
            category: MaterialTypeCategory.NATURAL,
            id: 1,
            createdAt: new Date(),
            updatedAt: new Date(),
            deletedAt: null,
            operationChainId: "1",
            typeTextContentId: 1,
            ecobalyseId: "1",
          },
          itemId: 11,
          translations: {
            EN: "Cotton",
            FR: "Coton",
            ES: "Algodón",
            DE: "Baumwolle",
            IT: "Cotone",
            NL: "Wol",
            id: 1,
            originalText: "Cotton",
          },
          proportion: 50,
        },
        {
          type: {
            category: MaterialTypeCategory.NATURAL,
            id: 1,
            createdAt: new Date(),
            updatedAt: new Date(),
            deletedAt: null,
            operationChainId: "1",
            typeTextContentId: 1,
            ecobalyseId: "1",
          },
          itemId: 12,
          translations: {
            EN: "Polyester",
            FR: "Polyester",
            ES: "Polyester",
            DE: "Polyester",
            IT: "Polyester",
            NL: "Polyester",
            id: 1,
            originalText: "Polyester",
          },
          proportion: 50,
        },
      ],
    },
    {
      itemId: 2,
      certificates: [],
      type: "component",
      translations: {
        EN: "Secondary component",
        FR: "Composant secondaire",
        ES: "Componente secondaire",
        DE: "Sekundärkomponente",
        IT: "Componente secondaria",
        NL: "Secundaire component",
        id: 1,
        originalText: "Secondary component",
      },
      materials: [
        {
          type: {
            category: MaterialTypeCategory.NATURAL,
            id: 1,
            createdAt: new Date(),
            updatedAt: new Date(),
            deletedAt: null,
            operationChainId: "1",
            typeTextContentId: 1,
            ecobalyseId: "1",
          },
          itemId: 21,
          translations: {
            EN: "Cotton",
            FR: "Coton",
            ES: "Algodón",
            DE: "Baumwolle",
            IT: "Cotone",
            NL: "Wol",
            id: 1,
            originalText: "Cotton",
          },
          proportion: 70,
        },
        {
          type: {
            category: MaterialTypeCategory.NATURAL,
            id: 1,
            createdAt: new Date(),
            updatedAt: new Date(),
            deletedAt: null,
            operationChainId: "1",
            typeTextContentId: 1,
            ecobalyseId: "1",
          },
          itemId: 22,
          translations: {
            EN: "Linen",
            FR: "Lin",
            ES: "Lino",
            DE: "Linen",
            IT: "Linen",
            NL: "Lin",
            id: 1,
            originalText: "Linen",
          },
          proportion: 30,
        },
      ],
    },
  ],
  ecoScoreData: {
    sources: {
      ecobalyse: {
        ecoScoreCost: 10,
        ecoScoreCostPer100g: 10,
        percentFilled: 10,
      },
      waro: {
        ecoScoreCost: 20,
        ecoScoreCostPer100g: 20,
      },
    },
    availableSources: ["ecobalyse", "waro"],
  },
  agecActivityCountriesByComponentsAndMaterials: {},
}

export const useGetAgecData = () => {
  const { user } = useAuth()
  return {
    ...agecData,
    organizationName: user?.organization?.name ?? "Company Name",
  }
}
